// components/FeedbackComment.js
import DocumentViewerModal from "components/DocumentViewer";
import FileView from "components/fileView";
import React from "react";
import { useTranslation } from "react-i18next";

// Helper function to get initials
const getInitials = (name: string) => {
    if (!name) return "";
    const parts = name.split(" ");
    if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// Helper function to get a consistent background color for initials (optional)
const getAvatarBgColor = (name: string) => {
    const colors = [
        "bg-[#AA232F]",
    ];
    if (!name) return colors[0];
    const hash = name
        .split("")
        .reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
};

interface FeedbackCommentProps {
    name: string;
    role: string;
    commentedDate: string;
    comment: string;
    status?: string;
    file?: any;
    file_type?: string;
    file_url?: string;
}

function FeedbackComment({
    name,
    role,
    commentedDate,
    comment,
    file,
    file_type,
    file_url,
    status,
}: FeedbackCommentProps) {
    const { t } = useTranslation();
    const initials = getInitials(name);
    const bgColor = getAvatarBgColor(name);

    return (
        <div className="items-start bg-gray-50 p-4 rounded-lg border border-gray-200">
            <div className="flex">
                {/* Avatar with Initials */}
                <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center text-white text-lg font-semibold flex-shrink-0 mr-3 ${bgColor}`}
                >
                    {initials}
                </div>

                <div>
                    <div className="font-semibold text-gray-800">{name}</div>
                    <div className="text-sm text-gray-500">{role}</div>
                    <div className="flex gap-2">
                        <div className="text-xs text-red-500 mb-2">{t("CommentedDate")}</div>
                        <div className="text-xs text-gray-500 mb-2">{commentedDate}</div>
                    </div>
                    <p className="text-gray-700 text-sm">{comment}</p>
                </div>
                {status &&
                    <div className="ml-auto bg-gray-200 h-fit px-2 py-1 font-semibold text-sm text-gray-800 rounded-lg">
                        <p>{status}</p>
                    </div>
                }
            </div>
            <div className="pl-12 mt-4">
                {Array.isArray(file) && file.length > 0 && (
                    <DocumentViewerModal
                        documents={
                            file_type
                                ? file.filter((document: any) => document.document_type === file_type)
                                : file
                        }
                        baseUrl={`${process.env.REACT_APP_API_BASE_URL}${file_url || "legal_research/legal-research-request-documents/document/"}`}
                    />
                )}
            </div>
        </div>
    );
}

export default FeedbackComment;